import { render, staticRenderFns } from "./breadcrumb-item.vue?vue&type=template&id=970ff26e&"
import script from "./breadcrumb-item.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('970ff26e')) {
      api.createRecord('970ff26e', component.options)
    } else {
      api.reload('970ff26e', component.options)
    }
    module.hot.accept("./breadcrumb-item.vue?vue&type=template&id=970ff26e&", function () {
      api.rerender('970ff26e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/breadcrumb/src/breadcrumb-item.vue"
export default component.exports